import { CustomColumnType } from "../grid-column-types";
import { columnCellCallbacks } from "../processCellCallbacks";
export const processCellForExportSelector = (params) => {
    let colType = params.column.getColDef().type;
    if (colType === CustomColumnType.InsTransposedColumn) {
        colType = params.node?.data.type;
    }
    if (Array.isArray(colType) && colType.length === 1) {
        [colType] = colType;
    }
    const colTypeArr = typeof colType === "string" ? [colType] : colType;
    const filtered = colTypeArr?.filter((cType) => Object.keys(columnCellCallbacks).includes(cType));
    if (filtered && filtered.length) {
        return columnCellCallbacks[filtered[0]](params, params.dataScale);
    }
    return params.value?.label ?? params.value;
};
